const ROOT = 'TRUSTED_TALENT_APPLICANT_';

const actions = {
  LOAD_FORM_DATA: `${ROOT}LOAD_FORM_DATA`,
  LOAD_FORM_DATA_SUCCESS: `${ROOT}LOAD_FORM_DATA_SUCCESS`,
  LOAD_FORM_DATA_ERROR: `${ROOT}LOAD_FORM_DATA_ERROR`,
  CHANGE_PROPERTY: `${ROOT}CHANGE_PROPERTY`,
  LOAD_TEMPLATE: `${ROOT}.LOAD_TEMPLATE`,
  LOAD_TEMPLATE_SUCCESS: `${ROOT}LOAD_TEMPLATE_SUCCESS`,
  LOAD_TEMPLATE_ERROR: `${ROOT}LOAD_TEMPLATE_ERROR`,
  UPLOAD_TRUSTED_TALENT: `${ROOT}UPLOAD_TRUSTED_TALENT`,
  UPLOAD_TRUSTED_TALENT_SUCCESS: `${ROOT}UPLOAD_TRUSTED_SUCCESS`,
  UPLOAD_TRUSTED_TALENT_ERROR: `${ROOT}UPLOAD_TRUSTED_TALENT_ERROR`,
  CLEAR_STATE: `${ROOT}CLEAR_STATE`,
} as const;

export default actions;
